import React from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
let serverUrl = window.location.href;
console.log(serverUrl);

function CompanyNavBar(props:any) {

    const data = props.data;
    const navigate = useNavigate();

    return (
        <React.Fragment>
        <div className="company-navbar">
            
            {!serverUrl.includes("/item/") &&
            
            <Link to={!props.product ? "/"  :"/company/"+ data.id } className="left-top">
                <img src="../img/back.svg" alt="back" className="back-arrow" />
            </Link>
            }

            {Object.keys(props.data).length != 0  ?
                <img src={props.data.logo} alt="logo" className="logo clickable-item"  onClick={() => {navigate(`/company/${data.id}`)}}/>
            :<></>}
        </div>
        </React.Fragment>
    );
}
export default CompanyNavBar;
